import styled from 'styled'

const Logo = styled.img`
  height: 24px;
  margin: ${props => props.theme.spaces.stack.xxs};
`
export default Logo
